import { mobileDeviceFullStore } from '../store/store';
import { toggleDeviceLoggingEnabled } from '../mutators/toggleDeviceLoggingEnabled';
import { toggleDeviceLoggingWindow } from '../mutators/toggleDeviceLoggingWindow';
import { updateNotSendReadReceipt } from '../mutators/updateNotSendReadReceipt';
import { resetMobileDevices } from '../mutators/resetMobileDevices';
import { markIsDevicesDirty } from '../mutators/markIsDevicesDirty';
import { markIsNotSendReadReceiptDirty } from '../mutators/markIsNotSendReadReceiptDirty';
import { markIsLoggingEnabledDirty } from '../mutators/markIsLoggingEnabledDirty';

export function onDiscardMobileOption() {
    let store = mobileDeviceFullStore();

    if (store.isLoggingEnabledDirty) {
        toggleDeviceLoggingEnabled();
        toggleDeviceLoggingWindow();
        markIsLoggingEnabledDirty(false);
    } else if (store.isNotSendReadReceiptDirty) {
        updateNotSendReadReceipt(store.casMailbox.ActiveSyncSuppressReadReceipt);
        markIsNotSendReadReceiptDirty(false);
    } else if (store.isDevicesDirty) {
        resetMobileDevices(store.deviceStatistics);
        markIsDevicesDirty(false);
    }
}
